export default __webpack_public_path__ + "static/media/h2-3.96f1ee1a.jpg";